import React from "react";

export default function Favorites() {
  return (
    <div style={{ textAlign: "center" }}>
      <h1>Coming Soon!</h1>
    </div>
  );
}
